<div class="col-lg-12 col-sm-12 col-12">                 
    <div class="card mb-4 card-danger">
        <div class="card-header">
            <h5 class="card-title text-white">Thành viên tham gia
                <span
                    *ngIf="ThanhVienPhanQuyenChucNangService.DataThanhVienThamgia">({{ThanhVienPhanQuyenChucNangService.DataThanhVienThamgia.length}}
                    items)</span>
            </h5>
        </div>
        <div class="card-body">
            <div class="table-outer">
                <div class="table-responsive">
                    <table mat-table matSort #ThanhVienPhanQuyenChucNangSort004="matSort"
                        [dataSource]="ThanhVienPhanQuyenChucNangService.DataThanhVienThamgia"
                        class="table table-striped m-0">
                        <ng-container matColumnDef="ThanhVienThamGia">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Thành viên tham gia
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <label>{{GetAgencyDepartmentNameByID(element.ParentID)}}</label>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Save">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <input type="checkbox" name="element.Active" [(ngModel)]="element.Active" (change)="ThanhVienPhanQuyenChucNangSave(element)">
                                <label>Tham gia</label>
                            </td>
                        </ng-container>
                        <tr mat-header-row
                            *matHeaderRowDef="ThanhVienPhanQuyenChucNangService.DisplayColumns004">
                        </tr>
                        <tr mat-row
                            *matRowDef="let row; columns: ThanhVienPhanQuyenChucNangService.DisplayColumns004;">
                        </tr>
                    </table>
                    <mat-paginator #ThanhVienPhanQuyenChucNangPaginator004="matPaginator"
                        [pageSizeOptions]="[10,20,50,100]" [pageSize]="20"
                        [showFirstLastButtons]="true"></mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>